(function() {
  function slugify(text) {
    return (text || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function normalizeText(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (typeof text === "string") element.textContent = text;
    return element;
  }

  function extractParagraphHeading(node) {
    if (!node || node.tagName !== "P" || node.children.length !== 1) return "";

    var child = node.children[0];
    if (!child || !/^(STRONG|B)$/i.test(child.tagName)) return "";

    var text = normalizeText(node.textContent);
    if (!text || normalizeText(child.textContent) !== text) return "";

    return text.replace(/[:：]\s*$/, "");
  }

  function stripArtifacts(scope) {
    scope.querySelectorAll("meta, script, style, .hidden, .visually-hidden").forEach(function(node) {
      node.remove();
    });

    scope.querySelectorAll("[aria-describedby]").forEach(function(node) {
      if ((node.getAttribute("aria-describedby") || "").indexOf("forwarding-") === 0) {
        node.removeAttribute("aria-describedby");
      }
    });
  }

  function sanitizeRichText(scope) {
    scope.querySelectorAll("p, h2, h3, h4, span, b, strong, em").forEach(function(node) {
      node.removeAttribute("class");
      node.removeAttribute("style");
    });
  }

  function convertBulletGroups(container) {
    var children = Array.prototype.slice.call(container.children);
    var currentList = null;

    children.forEach(function(node) {
      if (node.tagName === "P") {
        var text = normalizeText(node.textContent);
        if (/^[·•-]\s*/.test(text)) {
          if (!currentList) {
            currentList = createElement("ul", "policy-list");
            node.parentNode.insertBefore(currentList, node);
          }
          var item = createElement("li", "", text.replace(/^[·•-]\s*/, ""));
          currentList.appendChild(item);
          node.remove();
          return;
        }
      }
      currentList = null;
    });
  }

  function decorateParagraphs(container) {
    container.querySelectorAll("p").forEach(function(paragraph) {
      var text = normalizeText(paragraph.textContent);
      if (/^\d+\.\s*/.test(text)) {
        paragraph.classList.add("policy-step");
      } else if (/^note:/i.test(text)) {
        paragraph.classList.add("policy-note");
      }
    });
  }

  function wrapTables(container) {
    container.querySelectorAll("table").forEach(function(table) {
      if (table.parentElement && table.parentElement.classList.contains("policy-table-wrap")) {
        return;
      }

      var wrapper = createElement("div", "policy-table-wrap");
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function uniqueSectionId(baseId, usedIds) {
    var candidate = baseId || "policy-section";
    var count = 2;

    while (usedIds[candidate]) {
      candidate = baseId + "-" + count;
      count += 1;
    }

    usedIds[candidate] = true;
    return candidate;
  }

  function buildDocumentSections(sourceHtml, defaultTitle) {
    var sandbox = document.createElement("div");
    sandbox.innerHTML = sourceHtml;
    stripArtifacts(sandbox);
    sanitizeRichText(sandbox);

    var nodes = Array.prototype.slice.call(sandbox.childNodes).filter(function(node) {
      if (node.nodeType === 3) {
        return normalizeText(node.textContent) !== "";
      }
      return true;
    });

    var renderRoot = document.createElement("div");
    var hasExplicitSections = nodes.some(function(node) {
      return node.nodeType === 1 && node.tagName === "H2";
    });
    var usedIds = {};
    var currentSection = null;
    var currentTarget = null;

    function ensureSection(sectionTitle) {
      if (currentSection) return currentSection;

      var displayTitle = normalizeText(sectionTitle);
      var idSeed = slugify(displayTitle);
      if (!displayTitle) {
        if (hasExplicitSections) {
          displayTitle = "Overview";
          idSeed = "policy-overview";
        } else {
          displayTitle = defaultTitle + " details";
          idSeed = "policy-document-details";
        }
      }

      currentSection = createElement("section", "policy-section");
      currentSection.id = uniqueSectionId(idSeed || "policy-details", usedIds);

      var header = createElement("div", "policy-section-header");
      header.appendChild(createElement("h2", "", displayTitle));
      currentSection.appendChild(header);

      renderRoot.appendChild(currentSection);
      currentTarget = currentSection;
      return currentSection;
    }

    nodes.forEach(function(node) {
      if (node.nodeType === 3) {
        ensureSection();
        var paragraph = createElement("p", "", normalizeText(node.textContent));
        currentTarget.appendChild(paragraph);
        return;
      }

      if (node.tagName === "H2") {
        currentSection = null;
        currentTarget = null;
        ensureSection(node.textContent);
        return;
      }

      var paragraphHeading = extractParagraphHeading(node);
      if (paragraphHeading) {
        currentSection = null;
        currentTarget = null;
        ensureSection(paragraphHeading);
        return;
      }

      if (node.tagName === "H3" || node.tagName === "H4") {
        ensureSection();
        var subsectionTitle = normalizeText(node.textContent);
        var subsection = createElement("section", "policy-subsection");
        subsection.id = uniqueSectionId(slugify(subsectionTitle) || "policy-subsection", usedIds);
        subsection.appendChild(createElement("h3", "", subsectionTitle));
        currentSection.appendChild(subsection);
        currentTarget = subsection;
        return;
      }

      ensureSection();
      currentTarget.appendChild(node);
    });

    if (!renderRoot.children.length) {
      ensureSection(defaultTitle + " details");
    }

    Array.prototype.slice.call(renderRoot.querySelectorAll(".policy-section, .policy-subsection")).forEach(function(
      section
    ) {
      convertBulletGroups(section);
      decorateParagraphs(section);
      wrapTables(section);
    });

    return renderRoot;
  }

  function syncNav(navShell, sections) {
    if (!navShell) return;

    var nav = navShell.querySelector("[data-policy-nav]");
    var emptyState = navShell.querySelector("[data-policy-nav-empty]");
    if (!nav) return;

    nav.innerHTML = "";

    if (sections.length <= 1) {
      navShell.hidden = true;
      return;
    }

    navShell.hidden = false;
    if (emptyState) emptyState.hidden = true;

    sections.forEach(function(section) {
      var link = createElement("a", "", section.title);
      link.href = "#" + section.id;
      nav.appendChild(link);
    });
  }

  function bindActiveNav(navShell, sections) {
    if (!navShell) return;

    if (navShell._policyObserver) {
      navShell._policyObserver.disconnect();
      navShell._policyObserver = null;
    }

    if (sections.length <= 1 || !("IntersectionObserver" in window)) return;

    var links = Array.prototype.slice.call(navShell.querySelectorAll("[data-policy-nav] a"));
    if (!links.length) return;

    var linkMap = {};
    links.forEach(function(link) {
      linkMap[link.getAttribute("href")] = link;
    });

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          var link = linkMap["#" + entry.target.id];
          if (!link) return;

          if (entry.isIntersecting) {
            links.forEach(function(item) {
              item.classList.remove("is-active");
            });
            link.classList.add("is-active");
          }
        });
      },
      {
        rootMargin: "-25% 0px -55% 0px",
        threshold: 0.1
      }
    );

    sections.forEach(function(section) {
      observer.observe(section.node);
    });

    navShell._policyObserver = observer;
  }

  function enhancePolicyDocuments() {
    if (!document.body.classList.contains("template-policy")) return;

    document.querySelectorAll("[data-policy-document]").forEach(function(article) {
      var source = article.querySelector("[data-policy-richtext-source]");
      var renderTarget = article.querySelector("[data-policy-document-render]");
      if (!source || !renderTarget) return;

      var defaultTitle = normalizeText(article.getAttribute("data-policy-title")) || "Policy";
      var documentTree = buildDocumentSections(source.innerHTML, defaultTitle);
      var sectionNodes = Array.prototype.slice
        .call(documentTree.querySelectorAll(".policy-section"))
        .map(function(section) {
          return {
            id: section.id,
            title: normalizeText(section.querySelector(".policy-section-header h2").textContent),
            node: section
          };
        })
        .filter(function(section) {
          return section.id !== "policy-details";
        });

      renderTarget.innerHTML = "";
      Array.prototype.slice.call(documentTree.children).forEach(function(child) {
        renderTarget.appendChild(child);
      });

      article.classList.add("policy-article--enhanced");

      var navShell = document.querySelector("[data-policy-nav-shell]");
      syncNav(navShell, sectionNodes);
      bindActiveNav(navShell, sectionNodes);
    });

    var refundNavShell = document.querySelector("[data-policy-handle='refund-policy'] [data-policy-nav-shell]");
    if (refundNavShell) {
      var refundSections = Array.prototype.slice
        .call(document.querySelectorAll("[data-policy-handle='refund-policy'] .policy-section[id]"))
        .map(function(section) {
          var heading = section.querySelector(".policy-section-header h2");
          return heading
            ? {
                id: section.id,
                title: normalizeText(heading.textContent),
                node: section
              }
            : null;
        })
        .filter(Boolean);
      bindActiveNav(refundNavShell, refundSections);
    }
  }

  window.JapaneseSelectPolicyPage = {
    refresh: enhancePolicyDocuments
  };

  document.addEventListener("DOMContentLoaded", enhancePolicyDocuments);
  document.addEventListener("policy:content-updated", enhancePolicyDocuments);
})();
